import styled, { css } from 'styled-components';
import { MobileScreen } from '../../styles/ConstantMediaQuery';

const ModalContent = styled.div`
    margin: 0 auto;
    width: 550px;

    @media ${MobileScreen} {
        ${({ isNewModal }) => isNewModal && css`
            padding: 0 5vw;
        `};
        width: 100%;
    }
    
    ${({ styles }) => styles && { ...styles }};
`;

export default ModalContent;
